// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"88":"fd17dba9","178":"43984259"}[chunkId] + ".chunk.css";
};